import { useState, useEffect } from "react";
import { controls, Player } from "react-media-player";
import { usePodcastProvider } from "./PodcastProvider";
import { formatUnixTimestamp, secondsToHms } from "services/utils";
import { useMediaSource } from "hooks";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui
import { Flex, Text, Box, Image } from "@chakra-ui/react";
import { CustomMediaSlider, CustomPlayPause } from "./CustomMediaPlayer";
import PodcastColorTypes from "types/podcastColorTypes";

export function FeaturedContent() {
  const [displayProgressBar, setDisplayProgressBar] = useState<boolean>(true);
  const [playerSrc, setPlayerSrc] = useState("");
  const { CurrentTime } = controls;

  const { setPlayPodcast, playPodcast, setPlayingPodcast, podcastData, playingPodcast, isOpen } = usePodcastProvider();

  const heroPodcast = podcastData[0];
  const { startPlaying } = useMediaSource({ podcastDetails: heroPodcast });

  const podcastLength = heroPodcast && heroPodcast.length ? secondsToHms(heroPodcast?.length) : 0;

  const updateSource = () => {
    setPlayingPodcast(heroPodcast);
  };

  const handlePlayPodcast = () => {
    updateSource();
    setPlayPodcast(true);
  };

  const publishDate = heroPodcast?.created ? formatUnixTimestamp(heroPodcast.created) : "";
  const showPlayer = playingPodcast && !isOpen && playingPodcast?.episode_number === heroPodcast.episode_number;

  useEffect(() => {
    if (showPlayer) {
      const source = startPlaying();
      setPlayerSrc(source);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPlayer]);
  return (
    <Flex maxWidth="100%" width="100%" flexDir="column" alignItems="flex-end" mt={{ base: "32px", md: "0px" }}>
      <Flex
        width="100%"
        position="relative"
        onMouseEnter={() => {
          setDisplayProgressBar(true);
        }}
        onMouseLeave={() => {
          setDisplayProgressBar(false);
        }}
      >
        {playingPodcast?.audio_urls && showPlayer && (
          <>
            <Image
              src={heroPodcast?.thumbnail_url}
              display={showPlayer ? "flex" : "none"}
              alt="Episode Image"
              width="100%"
              minHeight={{ base: "184px", md: "352px" }}
              borderRadius={{ base: "12px", md: "16px" }}
            />
            <Box height="0px">
              <Player src={playerSrc} className="media-player" vendor="audio" style={{ display: isOpen ? "none" : "flex" }} autoPlay></Player>
            </Box>
          </>
        )}
        {playingPodcast?.video_urls && showPlayer && (
          <Box width="100%" height="auto" borderRadius={{ base: "12px", md: "16px" }} display={showPlayer ? "flex" : "none"}>
            <Player src={playerSrc} style={{ height: "452px !important", borderRadius: "16px", display: `${isOpen ? "none" : "flex"}` }} autoPlay={true} className="media-player"></Player>
          </Box>
        )}
        {playPodcast && showPlayer ? (
          <Box
            position="absolute"
            display={displayProgressBar ? "block" : "none"}
            width="100%"
            height="100%"
            fontSize="12px"
            lineHeight="16px"
            letterSpacing="2px"
            color="purple.50"
            zIndex="10"
            transition="all 0.3s ease-in-out"
          >
            <Flex height="100%" zIndex="10" flexDirection="column" width="100%" justifyContent="flex-end" px="18px" alignItems="flex-end">
              <Flex height="100%" zIndex="20" flexDirection="column" width="100%" justifyContent="center" alignItems="center">
                <CustomPlayPause podcastDetails={heroPodcast} />
              </Flex>
              <CustomMediaSlider />
              <Flex justifyContent="space-between" mb="7px" zIndex="100" mt="8px" width="100%" fontSize="12px" lineHeight="16px" fontFamily="sora" color="white">
                <div>
                  <CurrentTime />
                </div>

                <div>{podcastLength}</div>
              </Flex>
            </Flex>
          </Box>
        ) : (
          <>
            <Image src={heroPodcast?.thumbnail_url} alt="Episode Image" width="100%" height={{ base: "184px", md: "352px" }} borderRadius={{ base: "12px", md: "16px" }} />
            <Box position="absolute" width="100%" height="100%" fontSize="12px" lineHeight="16px" letterSpacing="2px" color="purple.50">
              <Flex position="absolute" zIndex="10" px="8px" width="auto" marginTop="18px" marginLeft="16px" py="4px" bgColor="gray.150" borderRadius="8px" display={{ base: "none", md: "flex" }}>
                Episode {heroPodcast?.episode_number}
              </Flex>
              <Flex height="100%" zIndex="10" flexDirection="column" width="100%" justifyContent="center" alignItems="center">
                {(heroPodcast?.audio_urls || heroPodcast?.video_urls) && (
                  <>
                    <CustomPlayPause handlePlayPodcast={handlePlayPodcast} podcastDetails={heroPodcast} />
                    <Flex zIndex="10" px="8px" width="auto" color="white" marginTop={{ base: "19px", md: "23px" }} py="4px" bgColor="rgba(137, 137, 199, 0.2)" borderRadius="8px">
                      Click here to start listening
                    </Flex>
                  </>
                )}
              </Flex>
            </Box>
          </>
        )}
      </Flex>
      <Flex
        flexDir="column"
        maxWidth={{ base: "100%", md: "536px" }}
        width="100%"
        bg="rgba(214, 214, 214, 0.2)"
        pl="24px"
        py="16px"
        pr="32px"
        alignItems={{ md: "flex-end" }}
        mt={{ base: "27px", md: "23px" }}
        textAlign={{ base: "left", md: "right" }}
      >
        <Text as="h5" fontWeight="600" fontSize="20px" lineHeight="24px">
          {heroPodcast?.title}
        </Text>
        <Text as="p" fontSize="14px" lineHeight="24px" mt="8px">
          {heroPodcast?.description}
        </Text>
        <Flex mt="8px" fontSize="12px" width="100%" lineHeight="16px" letterSpacing="2px" color={getPodcastThemeToken(PodcastColorTypes.FeaturedContentText)}>
          <Flex px="8px" py="4px" bg={getPodcastThemeToken(PodcastColorTypes.FeaturedContentBadgeOne)} borderRadius="8px">
            {podcastLength}
          </Flex>
          <Flex px="8px" py="4px" bg={getPodcastThemeToken(PodcastColorTypes.FeaturedContentBadgeTwo)} ml="24px" borderRadius="8px">
            {publishDate}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
